export default __webpack_public_path__ + "static/media/beep.cbd86f12.mp3";